import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Pagetitle from "../Components/Pagetitle";
import { getData } from "../Api";

function OurProduct() {
  const [trendingProducts, setTrendingProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await getData("/products");

        if (response.success) {
          setTrendingProducts(response.data || []);
        } else {
          setTrendingProducts([]);
        }
      } catch (error) {
        console.error("Error fetching trending products:", error);
        setTrendingProducts([]);
      }
    };

    fetchProducts();
  }, []);

  return (
    <main className="container-fluid"> 
      <Header />
      <Pagetitle /> 
      <section className="px-sm-5 py-5">
        <div className="row">
          {trendingProducts.length > 0 ? (
            trendingProducts.map((item, index) => (
              <div key={item.id} className="col-xl-3 col-lg-4 col-sm-6 mb-3">
                <Link to={`/product/${item.slug}`} className="linktext">
                  <div className="product-card">
                    <img
                      src={`${item.image}`}
                      className="product-image"
                      alt={item.title}
                    />
                    <h5 className="product-title">{item.title}</h5>
                    <p className="product-price">
                      ₹{item.discount_price ? item.discount_price : item.price}
                    </p>
                    <button className="btn btn-cart">Add To Cart</button>
                  </div>
                </Link>
              </div>
            ))
          ) : (
            <p className="text-center w-100">No trending products available</p>
          )}
        </div>
      </section>
      <Footer />
    </main>
  );
}

export default OurProduct;
